import { Component, Input} from '@angular/core';
import { DynamicTabsService } from '../dynamic-tabs.service';
import { SideNavToggle } from '../shared/sidenav-toggle.model';
import { IHome, INavbarData } from '../sidenav/helper';
import { navbarData } from '../sidenav/nav-data';
import { HomeService } from '../services/homeservice';
import { ActivatedRoute, Router } from '@angular/router';


@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent {
  isSideNavCollapsed = false;
  navbarData = navbarData;
  @Input() policies:IHome[]=[];
  policy: IHome = new IHome();
  @Input() collapsed = false;
  @Input() screenWidth = 0;
  currentRouter = this.router.url;

  constructor(private router: Router, private activatedRoute: ActivatedRoute,
    public dynamicTabsService: DynamicTabsService,
    private service: HomeService, private actRoute : ActivatedRoute
  ){
    this.actRoute.queryParams.subscribe(params => {
      let id =params["UserId"];
      if(id==null|| id=='undefined')
       id='0';
       sessionStorage.setItem('UserId',id);
        // this.service.IsUserValidated(81).subscribe({
        this.service.IsUserValidated(+id).subscribe({
        next:(res:boolean)=>{
        sessionStorage.setItem('userLoggedIn',String(res).toString());
        //  console.log(res );
        if (!res)
          this.router.navigate(['/noaccess']);
      },
      error:(error)=>{
        this.router.navigate(['/noaccess']);
      }
    });
  });
  }
  ngOnInit():void
  {
  }
 
  onToggleSideNav(data: SideNavToggle): void {
    this.screenWidth = data.screenWidth;
    this.isSideNavCollapsed = data.collapsed;
  }
  isCollapsed:boolean=true;
  
  toggleSidebar(){
    this.isCollapsed= !this.isCollapsed;
  }
  handleClick(data: INavbarData): void {
    if (data.items && data.items.length > 0) {
      data.expanded = !data.expanded;
    }
  }

  getActiveClass(data: INavbarData): string {
    return data.expanded ? 'active-sublevel' : '';
  }
  //save
  saveClick(){
    sessionStorage.setItem('saveBtn','true');
    this.dynamicTabsService.saveClicked();
  }
  //delete
  deleteClick()
  {
    sessionStorage.setItem('deleteBtn','true');
    this.dynamicTabsService.deleteClicked(true);
  }

  // refresh
  refreshClick(){
   
    sessionStorage.setItem('refreshBtn','true');
    this.dynamicTabsService.refreshClicked();
  }
  // renew

  renewClick(){
    sessionStorage.setItem('renewBtn','true');
    this.dynamicTabsService.renewClicked();
  }

  //addnew-close
}
